<template>
  <header class="fixed z-10 flex min-h-[4rem] w-full items-center bg-gray-600">
    <LanguageSwitcher class="ml-auto p-2" />
  </header>
</template>
